import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router';
import has from 'lodash/has';

const ObjectableType = styled.span`
  color: #5bc0de;
  font-weight: 700;
`;

const Delete = props => {
  const { activity } = props;

  return (
    <span>
      <Link>
        {has(activity, ['user', 'first_name']) ? activity.user.first_name : ''}
        {' '}
        {has(activity, ['user', 'last_name']) ? activity.user.last_name : ''}
      </Link>{' '}
      deleted{' '}
      <ObjectableType>
        <Link>{has(activity, ['data', 'prev', 'name']) ? activity.data.prev.name : ''}</Link>
      </ObjectableType>
    </span>
  );
};

Delete.propTypes = {
  activity: PropTypes.object,
};

export default Delete;



// WEBPACK FOOTER //
// ./src/components/ActivityFeed/ActivityTypes/Delete.js